import { createSlice } from "@reduxjs/toolkit";

const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    isFetching: false,
    error: false,
    walletData: [],
    withdrawalData: [],
    message: "",
    creditUser: null,
  },
  reducers: {
    getWalletDataStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getWalletDataSucess: (state, action) => {
      state.isFetching = false;
      state.walletData = action.payload;
    },
    getWalletDataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getWithdrawalDataStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getWithdrawalDataSucess: (state, action) => {
      state.isFetching = false;
      state.withdrawalData = action.payload;
    },
    getWithdrawalDataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    creditUserStart: (state) => {
      state.isFetching = true;
      state.error = false;
      state.message = "";
    },
    creditUserSuccess: (state, action) => {
      state.isFetching = false;
      state.creditUser = action.payload;
      state.message = action.payload.message;
    },
    creditUserFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.message = action.payload?.message || "An error occurred.";
    },
    clearMessage: (state) => {
      state.message = ""; 
    },
    
  },
});

export const {
  getWalletDataStart,
  getWalletDataSucess,
  getWalletDataFailure,
  getWithdrawalDataStart,
  getWithdrawalDataSucess,
  getWithdrawalDataFailure,
  creditUserStart,
  creditUserSuccess,
  creditUserFailure,
  clearMessage
} = walletSlice.actions;
export default walletSlice.reducer;
